/*
 * @namespace Data
 * @aka COMMON.Data
 */
COMMON.Data = function ($) {

  var workers = {};

  /**
   * ------------------------------------------------------------------------
   * Private Helpers
   * ------------------------------------------------------------------------
   */

  /**
   * @param data
   * @param id
   * @private
   */
  var _setStorage = function _setStorage(data, id = null) {
    $.each(data, function (key, value) {
      id = id.replace(':' + key, '');
      key = id ? id + '.' + key : key;

      COMMON.Storage.session.setItem(key, value);

      if(id) {
        $(document).trigger('common:data', {
          key: key.replace(id + '.', ''),
          id: id
        })
      } else {
        $(document).trigger('common:data', {
          key: key
        })
      }
    })
  };

  /**
   * @param config
   * @private
   */
  var _update = function _update(config) {
    fetch(config.url, {
      cache: 'no-cache',
      headers: {
        'Accept': 'application/json, */*; q=0.01',
        'X-Requested-With': 'XMLHttpRequest'
      },
      method: 'GET',
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      var response = {};
      if (config.hasOwnProperty('alias') && null !== config.alias) {
        response[config.alias] = data;
      } else {
        response = data;
      }
      _setStorage(response);
    }).catch(function (error) {
      console.error(error.stack || error);
    });
  };

  /**
   * @param fn
   * @returns {string}
   * @private
   */
  var _fn2workerURL = function (fn) {
    var blob = new Blob(["(" + fn.toString() + ")()"], {
      type: "application/javascript"
    });
    return URL.createObjectURL(blob);
  };

  /**
   * @private
   */
  var _feedfetcherWorker = function () {
    var _timeoutID = null;
    var controller = null;

    onmessage = function (event) {
      var that = self;
      var config;

      if (event.data) {
        config = event.data;
      }
      if (!config || !config.hasOwnProperty('url')) {
        return;
      }

      // Laufendes Interval beenden, bevor ein neues startet
      if (_timeoutID !== null) {
        clearInterval(_timeoutID);
        _timeoutID = null;
      }

      var _getData = function (url) {
        // cancel pending request if any
        if (controller) {
          controller.abort();
        }

        // make our request cancellable
        controller = new AbortController();
        var signal = controller.signal;

        fetch(url, {
          cache: 'no-cache',
          headers: {
            'Accept': 'application/json, */*; q=0.01',
            'X-Requested-With': 'XMLHttpRequest'
          },
          method: 'GET',
          credentials: 'same-origin',
          signal: signal
        }).then(function (response) {
          controller = null;
          return response.json();
        }).then(function (jsonResponse) {
          that.postMessage(jsonResponse);
        }).catch(function (exception) {
          if ('AbortError' === exception.name) {
            console.debug('Fetch aborted');
            return;
          }
          console.error(exception.stack || exception);
        });
      };

      if (config.hasOwnProperty('interval') && null !== config.interval) {
        _timeoutID = setInterval(_getData, config.interval, config.url);
      }
      _getData(config.url);
    };

  };

  /**
   * @param id
   * @param feed
   * @private
   */
  var _subscribe = function(id, config) {
    if (workers.hasOwnProperty(id)) {
      return false;
    }

    if (window.Worker) {
      // create worker
      workers[id] = new window.Worker(_fn2workerURL(_feedfetcherWorker));

      // handle worker response
      workers[id].onmessage = function (event) {
        var data = event.data;
        if (data) {
          var response = {};
          if (config.hasOwnProperty('alias') && null !== config.alias) {
            response[config.alias] = data;
          } else {
            response = data;
          }
          _setStorage(response, id);
        }
      };

      // start workers with config
      workers[id].postMessage({
        url: config.url,
        interval: config.interval
      })
    } else {
      if (config.hasOwnProperty('interval') && null !== config.interval) {
        workers[id] = window.setInterval(_update, config.interval, config);
      }
      _update(config);
    }
  };

  /**
   * @param id
   * @returns {boolean}
   * @private
   */
  var _unsubscribe = function (id) {
    if (!workers.hasOwnProperty(id)) {
      return false;
    }

    if (window.Worker) {
      workers[id].terminate();
    } else {
      window.clearInterval(workers[id])
    }

    delete workers[id];

    return true;
  };


  $(document).on('common:data:subscribe', function (event, name, data) {
    COMMON.Utils.typeCheckConfig('COMMON.Data', data, {
      url: 'string',
      interval: '(undefined|null|number)',
      alias: '(undefined|null|string)'
    });

    // url must be absolute in worker
    var url = COMMON.Utils.parseUrl(data.url);
    data.url = url.protocol + '://' + url.host + ("" !== url.port ? ':' + url.port : '') + url.relative;

    _subscribe(name, data)
  });

  $(document).on('common:data:unsubscribe', function (event, name) {
    _unsubscribe(name)
  });

  /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */

  var Data = {
    get: function get(key) {
      return COMMON.Storage.session.getItem(key);
    }
  };

  return Data;

}(window.jQuery);
